import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const DataTableCard = styled.div`
    color: ${colors.greyscale.darker_grey};
    font-size: 16px;

    /* .p-datatable .p-column-header-content {
        display: block;
    } */

    .p-datatable .p-datatable-thead > tr > th{
        background: white;
        font-size: 14px;
        color: ${colors.greyscale.darker_grey};
        padding: 0.2rem 2rem;
        font-weight: bold;
        outline-width: 5px;
    }

    .p-datatable .p-datatable-thead .pi {
        font-size: 12px;
    }

    .p-datatable .p-datatable-tbody > tr {
        background: ${colors.mainColors.white_lilac};
        margin-bottom: 5px;
        box-shadow: 5px 0px 0px 0px ${colors.greyscale.dark_grey} inset;
        cursor: default;
    }

    .p-datatable .p-datatable-tbody > tr > td {
        border: 2px solid white;
        padding: 0.3rem 1rem;
    }

    .p-datatable .p-datatable-tbody .pi {
        font-weight: bold;
    }

    .p-splitbutton.p-button-text > .p-button {
        color: ${colors.greyscale.darker_grey} !important;
    }

    .p-discipline{
        box-shadow: 5px 0px 0px 0px ${colors.mainColors.blueberry} inset !important;
    }

    .p-item, .p-partner{
        box-shadow: 5px 0px 0px 0px ${colors.mainColors.verde_dstore} inset !important;
    }

    .p-theme{
        box-shadow: 5px 0px 0px 0px ${colors.mainColors.roxo_delinea} inset !important;
    }

    .p-media{
        box-shadow: 5px 0px 0px 0px ${colors.mainColors.capri} inset !important;
    }

    .p-guest{
        box-shadow: 5px 0px 0px 0px ${colors.mainColors.blueberry} inset !important;
    }
    
    .p-subscriber{
        box-shadow: 5px 0px 0px 0px ${colors.mainColors.minsk} inset !important;
    }

    .p-inactive {
        color: ${colors.greyscale.dark_grey} !important;
    }

    .p-lead {
        box-shadow: none !important;
    }
`